/*
 * ScrollClass
 * Add/remove class to element and/or body based on if
 * element is top of viewport.
 */
class ScrollClass {
  element;

  elementClass = 'is-active';

  bodyClass;

  position = 0;

  offset = 0;

  constructor({
    element,
    offset,
    elementClass,
    bodyClass,
  }) {
    // return, no element
    if (!element) {
      return;
    }

    // properties
    this.bodyClass = bodyClass || this.bodyClass;
    this.element = element;
    this.elementClass = elementClass || this.elementClass;
    this.offset = offset || this.offset;

    // initialize
    this.init();
  }

  // initialize
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.initialPosition();
      document.addEventListener('scroll', () => this.handleWaypoint());
    });
  }

  // get position ~ element top of viewport plus additional offset
  initialPosition() {
    const body = document.body.getBoundingClientRect();
    const element = this.element.getBoundingClientRect();

    this.position = element.top - body.top + this.offset;
  }

  // handle waypoint
  handleWaypoint() {
    const trueOrFalse = window.pageYOffset > this.position;

    this.setClass(this.element, this.elementClass, trueOrFalse);
    this.setClass(document.body, this.bodyClass, trueOrFalse);
  }

  // set class
  // eslint-disable-next-line class-methods-use-this
  setClass(element, className, trueOrFalse) {
    if (element && className) {
      element.classList.toggle(className, trueOrFalse);
    }
  }
}

// eslint-disable-next-line no-new
new ScrollClass({
  element: document.querySelector('#js-search__filters'),
});

/*
 * toggle self
 * toggle class on self events.
 */
const eventToggleSelf = () => {
  const elements = document.querySelectorAll('[data-js-self]');

  // return, no buttons found
  if (!elements) {
    return;
  }

  // loop elements
  elements.forEach((element) => {
    element.addEventListener('click', (ev) => {
      ev.preventDefault();
      element.classList.toggle(element.dataset.jsSelf || 'is-active');
    });
  });
};

/*
 * toggle remote
 * toggle class on remote elements.
 */
const eventToggleRemote = () => {
  const elements = document.querySelectorAll('[data-js-remote]');

  // return, no elements found
  if (!elements) {
    return;
  }

  // loop elements
  elements.forEach((element) => {
    // return, element must have data-remote
    if (!element.dataset.jsRemote) {
      return;
    }

    // find remote element
    const remoteElements = document.querySelectorAll(`[data-js-remote-target="${element.dataset.jsRemote}"]`);

    // return, no remote element
    if (!remoteElements.length) {
      return;
    }

    // element click
    remoteElements.forEach((remoteElement) => {
      element.addEventListener('click', () => {
        remoteElement.classList.toggle(element.dataset.jsRemoteClass || 'is-active');
      });
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  eventToggleSelf();
  eventToggleRemote();
});
